/**
 * Icon Tabler (webfont nạp trong public/index.html) — cùng bộ với backoffice
 * và với bản demo tham chiếu.
 *
 *   <TIcon name="home" />   ->   <i class="ti ti-home" />
 */
import React from "react";

const TIcon: React.FC<{ name: string; className?: string }> = ({
  name,
  className = "",
}) => <i className={`ti ti-${name} ${className}`.trim()} aria-hidden="true" />;

export default TIcon;
